import { RootState } from '@iwProvider/configureStore';
import { Account } from './dashboard/Dashboard.types';

export const getRepaymentSchedule = (state: RootState, account: Account) => {
    const scheduledPayments = account?.scheduled_payments ?? null;
    return scheduledPayments
        ? scheduledPayments
        : // @ts-ignore-error ts-ignore I think this is a bug, but potentially never gets to this as scheduledPayments always exists??
          state?.iwocapayDashboard?.selectedPlan?.schedule ?? {};
};

export const getNextRepayment = (state: RootState, account: Account) => {
    return getRepaymentSchedule(state, account).schedule[0];
};

type TSchedule = NonNullable<
    NonNullable<Account['scheduled_payments']>['schedule']
>[number];

export const getTotalPrincipleFromSchedule = (
    state: RootState,
    account: Account
) => {
    const { schedule } = getRepaymentSchedule(state, account);

    const totalPrinciple = schedule.reduce(
        (total: number, schedule: TSchedule) => total + schedule.principal,
        0
    );

    return totalPrinciple;
};

export const getTotalInterestFromSchedule = (
    state: RootState,
    account: Account
) => {
    const { schedule } = getRepaymentSchedule(state, account);

    const totalInterest = schedule.reduce(
        (total: number, schedule: TSchedule) => total + schedule.interest,
        0
    );

    return totalInterest;
};
